{
  "name": "angular-client",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-with-browser": "ng serve -o --port 6223",
    "startdebug": "ng serve",
    "startlocal": "ng serve -c testlocal",
    "buildcheck": "ng build -c buildCheck",
    "build": "ng build",
    "buildprod": "ng build -c production",
    "buildtest": "ng build -c test",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.0",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/google-maps": "^18.2.14",
    "@angular/localize": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-svg-core": "^6.5.2",
    "@fortawesome/free-solid-svg-icons": "^6.5.2",
    "@mapbox/mapbox-gl-draw": "^1.5.1",
    "@ng-idle/core": "^15.0.0",
    "@ng-idle/keepalive": "^15.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@tinymce/tinymce-angular": "^9.1.0",
    "@turf/turf": "^7.3.3",
    "angular-client": "file:",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.5.1",
    "cldr-data": "^36.0.1",
    "core-js": "^3.36.1",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "jspdf": "^3.0.3",
    "jspdf-autotable": "^5.0.2",
    "luxon": "^3.4.4",
    "mapbox-gl": "^3.18.1",
    "primeicons": "^7.0.0",
    "primeng": "^17.18.12",
    "quill": "^2.0.3",
    "rxjs": "^7.8.1",
    "sass": "^1.75.0",
    "tinymce": "^8.1.2",
    "tslib": "^2.6.2",
    "xlsx": "^0.18.5",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.1",
    "@angular-eslint/builder": "^18.3.0",
    "@angular-eslint/eslint-plugin": "^18.3.0",
    "@angular-eslint/eslint-plugin-template": "^18.3.0",
    "@angular-eslint/schematics": "^18.3.0",
    "@angular-eslint/template-parser": "^18.3.0",
    "@angular/cli": "^18.2.1",
    "@angular/compiler-cli": "^18.2.0",
    "@angular/language-service": "^18.2.0",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "^5.1.4",
    "@types/jasminewd2": "^2.0.13",
    "@types/luxon": "^3.4.2",
    "@types/mapbox__mapbox-gl-draw": "^1.4.9",
    "@types/node": "^20.12.7",
    "@typescript-eslint/eslint-plugin": "7.7.0",
    "@typescript-eslint/parser": "7.7.0",
    "eslint": "^8.47.0",
    "jasmine-core": "^5.1.2",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "ts-node": "^10.9.2",
    "typescript": "5.4.5"
  }
}
